import { graphql, useStaticQuery } from "gatsby"
//import { useLocalization } from "gatsby-theme-i18n"
import { useI18next } from "gatsby-plugin-react-i18next"

const useGlobalPages = () => {
  //const { locale } = useLocalization()
  const { language: locale } = useI18next()

  const data = useStaticQuery(graphql`
    query GlobalPagesQuery {
      pages: allCollectionPages(filter: { fields: { type: { ne: null } } }) {
        nodes {
          locale
          title
          url
          fields {
            type
          }
        }
      }
    }
  `)

  const pages = data.pages.nodes.filter(n => n.locale === locale)

  return pages.reduce((acc, item) => {
    for (let i = 0; i < item.fields.type.length; i++) {
      acc[item.fields.type[i]] = {
        title: item.title,
        url: item.url,
      }
    }
    return acc
  }, {})
}

export default useGlobalPages
